import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  recordsPerPage: 10,
  pageNumber: 1,
};

export const manageContactsSlice = createSlice({
  name: 'manageContacts',
  initialState: INITIAL_STATE,
  reducers: {
    setRecordsPerPage: (state, action) => {
      state.recordsPerPage = action.payload;
    },
    setPageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },

    resetManageContacts: (state, action) => {
      state.recordsPerPage = INITIAL_STATE.recordsPerPage;
      state.pageNumber = INITIAL_STATE.pageNumber;
    },
  },
});

export const { setRecordsPerPage, setPageNumber, resetManageContacts } =
  manageContactsSlice.actions;

export default manageContactsSlice.reducer;
